<template>
  <div v-if="currentUser" class="col-12 col-md-12">
    <form @submit.prevent="validateInformation" class="p-t-15" role="form" novalidate="novalidate">
      <div class="col-10 offset-1 col-md-6 offset-md-3">
        <CommonValidationForm :currentUser="currentUser"></CommonValidationForm>
      </div>

      <div class="col-md-12 p-t-30">
        <h4 class="section-title">
          <span>{{ $i18n.t('EditProfile.information_professional') }}</span>
        </h4>
        <div class="user-entities-cards">
          <div class="card" v-for="addOn in addOns" v-if="addOn.aasm_state == 'pending'">

            <div class="card-header">
              <div class="row">
                <div class="col">
                  <div><b>{{ addOn.entity.name }}</b></div>
                  <div class="text-muted">
                {{ addOn.resource_type == 'intern' ? $i18n.t('models.resource_type.intern') : $i18n.t('models.resource_type.extern') }}
                  </div>
                </div>

                <div class="col">
                  <div class="btn-toolbar flex-wrap justify-content-end">
                    <div class="btn-group">
                      <a class="btn btn-icon" @click.prevent="editValidationForm(addOn)">
                        <i class="fa fa-edit"></i>
                      </a>
                      <div class="btn btn-icon-dark" @click.prevent="deleteEntity(addOn)">
                        <i class="fa fa-trash-o"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div class="card-body">
              <div class="row">
                <div class="col-md mb-3 mb-md-0">
                  <div class="description">Service(s) de remplacement(s): </div>
                  <services-grouped-by-hubs :services="addOn.services" :hubs="hubsFor(addOn)" />
                </div>

                <div class="col-md mb-3 mb-md-0" v-if="addOn.affiliated_service">
                  <div class="description">Service de rattachement: </div>
                  <services-grouped-by-hubs v-if="addOn.affiliated_service"
                                            :hubs="hubsFor(addOn)"
                                            :services="[addOn.affiliated_service]"
                                            :shortened="true" />
                </div>

                <div class="col-md mb-3 mb-md-0">
                  <div class="description">Métier(s): </div>
                  <b>{{ occupation_name(addOn) }}</b>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="col-md-12 no-padding sm-p-l-10 required accept-cgu text-center">
        <div class="checkbox">
          <input v-model="currentUser.acceptCGU" id="acceptCGU" name="acceptCGU" v-validate="'required'" type="checkbox"/>
          <label for="acceptCGU">
            {{ $t("SignUpForm.accept") }}
            <a target="_blank" :href=externalLinks.termsOfService>
              {{ $t("SignUpForm.cgu_link") }}
            </a>
          </label>
        </div>
      </div>
      <transition name="slide-fade">
        <label v-show="errors.has('acceptCGU')" class="error text-center" for="acceptCGU">
          {{ errors.first('acceptCGU') }}
        </label>
      </transition>

      <div class="col-md-12 validate-button">
        <button class="btn btn-primary btn-cons m-t-10" type="submit">
          {{ $t("form.update_information.button") }}
        </button>
      </div>
    </form>

    <div class="modal fade slide-up popup-validation-form" tabindex="-1" role="dialog" aria-hidden="false">
      <div class="modal-dialog">
        <PopupValidationForm v-if="dataAddOn"
                             :isIE="isIE"
                             :dataAddOn="dataAddOn"
                             :available-hubs="hubsOptions"
                             :availableServices="servicesOptions"
                             :availableOccupations="occupationsOptions"
                             :currentUser="currentUser"
                             :addOns="addOns"
                             :key="addOnPopupKey" />
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { externalLinks } from "../../settings/externalLinks";
  import { formatNumber, parseNumber } from 'libphonenumber-js'
  import ie_mixin from '@/mixin/ie'
  import PopupValidationForm from './PopupValidationForm'
  import CommonValidationForm from './CommonValidationForm'
  import ServicesGroupedByHubs from '@/components/hubs/ServicesGroupedByHubs'

  export default {
    name: "MSValidationForm",
    components: {
      PopupValidationForm,
      CommonValidationForm,
      ServicesGroupedByHubs
    },
    mixins: [ie_mixin],
    props: ['currentUser'],
    provide: ['$validator'],
    data: function() {
      return {
        dataAddOn: null
      }
    },
    computed: {
      ...mapGetters({
        addOns: 'users/addOns',
        addOnPopupKey: 'users/addOnPopupKey',
        serverErrors: 'users/errors',
        hasErrors: 'users/hasErrors',
        hubsOptions: 'users/allHubs',
        servicesOptions: 'users/allServices',
        occupationsOptions: 'users/manageableOccupations'
      }),
      externalLinks () {
        return externalLinks
      },
      tableHeadings() {
        return [{'key': 'entity', 'value': this.$i18n.t('table.headers.entity')},
                {'key': 'internal', 'value': this.$i18n.t('table.headers.candidate_entity_internal')},
                {'key': 'services', 'value': this.$i18n.t('table.headers.services')},
                {'key': 'affiliation_service', 'value': this.$i18n.t('table.headers.affiliation_service')},
                {'key': 'occupations', 'value': this.$i18n.t('table.headers.occupation')},
                {'key': 'actions', 'value': this.$i18n.t('table.headers.actions')}]
      },
    },
    methods: {
      deleteEntity(addOn) {
        var self = this
        this.$dialog.confirm(this.$i18n.t('UserForm.delete_confirmation')).then(function () {
          let addOns = self.addOns.filter(a => a.entity.id != addOn.entity.id)
          self.$store.commit('users/SET_ADDONS', addOns)
        })
        .catch(function () {})
      },
      editValidationForm(addOn) {
        this.dataAddOn = addOn
        $('.popup-validation-form').modal('show');
      },
      validateInformation() {
        this.$validator.validateAll().then((result) => {
          if (result && !this.hasErrors) {
            this.currentUser.phone = formatNumber(parseNumber(this.currentUser.phone_display, 'FR'), 'E.164')
            let options = {
              okText: this.$i18n.t('buttons.confirm'),
              cancelText: this.$i18n.t('buttons.cancel')
            }

            let user = this.currentUser
            user.add_ons = this.addOns
            this.$store.dispatch('users/updateProfile', user)
            .then(() => {
              this.$store.dispatch('auth/signOut');
              this.$router.replace({name: 'SignUpConfirmationPage'})
            }).catch((err) => {
            })
          }
        })
      },
      services_name(addOn){
        return addOn.services.map(service => service.name).join(' / ')
      },
      occupation_name(addOn){
        return addOn.occupations.map(occupation => occupation.name).join(' / ')
      },
      hubsFor(addOn) {
        if(!addOn || !addOn.entity) {
          return []
        }

        return addOn.entity.hubs
      }
    },
    mounted: function(){
      if(this.currentUser) {
        this.$store.commit('users/SET_ADDONS', this.currentUser.user_entities)
      }
    }
  }
</script>

<style scoped>
  h4.section-title {
    width: 100%;
    text-align: left;
    border-bottom: 2px solid #f1f1f1;
    line-height: 0.1em;
    margin: 10px 0 20px;
    font-family: 'Montserrat';
    font-weight: 600;
    font-size: 14px;
  }

  .section-title span {
    background: #fff;
    padding: 0 10px;
    text-transform: uppercase;
  }

  .accept-cgu a {
    text-decoration: underline;
  }

  .validate-button {
    text-align: center;
    margin-bottom: 20px;
  }
</style>



// WEBPACK FOOTER //
// src/components/candidate/MSValidationForm.vue